module.exports = __webpack_public_path__ + "static/agatawork4-0f7944ac032155934048deb902140eb3.jpg";